import {useId, useState} from 'react';

export function TelemetryTabs({samples, children, language = 'en'}) {
  const it=language==='it';
  const [tab,setTab]=useState('table');
  const [selected,setSelected]=useState('');
  const id=useId();
  const recent=samples.slice(-30);
  const numeric=(v)=>typeof v==='number' && Number.isFinite(v);
  const signals=new Map();
  for(const sample of recent) for(const [key,metric] of Object.entries(sample.measurements || {})) {
    if(numeric(metric?.value)) signals.set(key,metric);
  }
  const key=signals.has(selected) ? selected : signals.has('temperature') ? 'temperature' : signals.keys().next().value;
  const metric=signals.get(key);
  const label=(key,metric)=>metric?.label || key?.replace(/([a-z])([A-Z])/g,'$1 $2').replace(/[_-]/g,' ');
  const values=recent.map(sample=>{
    const m=sample.measurements?.[key];
    return numeric(m?.value) && (m.unit || '')===(metric?.unit || '') ? m.value : null;
  });
  const valid=values.filter(v=>v!==null);
  const low=Math.min(...valid), high=Math.max(...valid);
  const pad=high===low ? Math.max(Math.abs(high)*0.05,1) : (high-low)*0.1;
  const min=low-pad, max=high+pad;
  const y=v=>165-(v-min)/(max-min)*140;
  const x=i=>20+i/Math.max(1,values.length-1)*960;
  const path=values.map((v,i)=>v===null?'':`${i && values[i-1]!==null?'L':'M'} ${x(i)} ${y(v)}`).join(' ');
  const format=v=>new Intl.NumberFormat('en',{maximumFractionDigits:2}).format(v);
  return <div className="telemetry-views">
    <div className="telemetry-tabs" role="tablist" aria-label="Telemetry view">
      {['table','chart'].map(name=><button key={name} type="button" role="tab" id={`${id}-${name}`} aria-controls={`${id}-${name}-panel`} aria-selected={tab===name} tabIndex={tab===name?0:-1} onClick={()=>setTab(name)} onKeyDown={e=>{
        if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) {e.preventDefault();const next=e.key==='Home'?'table':e.key==='End'?'chart':name==='table'?'chart':'table';setTab(next);document.getElementById(`${id}-${next}`)?.focus();}
      }}>{name==='table'?(it?'Tabella':'Table'):(it?'Grafico':'Chart')}</button>)}
    </div>
    <div role="tabpanel" id={`${id}-table-panel`} aria-labelledby={`${id}-table`} hidden={tab!=='table'}>{children}</div>
    <div role="tabpanel" id={`${id}-chart-panel`} aria-labelledby={`${id}-chart`} hidden={tab!=='chart'}>
      <div className="chart-panel panel">
        {!signals.size ? <p>{it?'Nessun campione numerico disponibile.':'No numeric samples available yet.'}</p> : <>
          <div className="telemetry-chart-controls"><label htmlFor={`${id}-signal`}>{it?'Segnale':'Signal'}</label><select id={`${id}-signal`} value={key} onChange={e=>setSelected(e.target.value)}>{[...signals].map(([k,m])=><option key={k} value={k}>{label(k,m)}{m.unit?` (${m.unit})`:''}</option>)}</select><small>{it?'ULTIMI':'LAST'} {recent.length} {it?'CAMPIONI RICEVUTI':'RECEIVED SAMPLES'}</small></div>
          <div className="chart-head"><span>{label(key,metric)} · {metric.unit || (it?'unità non specificata':'unit not specified')}</span><span>{format(min)} — {format(max)}</span></div>
          <svg viewBox="0 0 1000 180" preserveAspectRatio="none" role="img" aria-label={`${label(key,metric)} trend, ${valid.length} valid samples`}>
            <g className="grid-lines">{[30,75,120,165].map(y=><line key={y} x1="0" y1={y} x2="1000" y2={y}/>)}</g>
            <path className="line-temp" d={path}/>
            {values.map((v,i)=>v===null?null:<circle key={i} cx={x(i)} cy={y(v)} r="3" fill="var(--amber)"><title>{format(v)} {metric.unit || ''} · {recent[i].observedAt || `Sample ${i+1}`}</title></circle>)}
          </svg>
          <div className="chart-legend"><small>{it?'Dal meno recente al più recente · Campioni della sessione · Scala automatica':'Oldest → newest · Session samples · Automatic scale'}</small></div>
          {valid.length<2 && <p>{it?'In attesa di altri campioni per visualizzare un andamento.':'Waiting for more samples to display a trend.'}</p>}
        </>}
      </div>
    </div>
  </div>;
}
